import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Puff } from 'react-loader-spinner'
import { BiTrash, BiMinusCircle } from 'react-icons/bi'

import styles from './styles.module.css'
import Li from '../../components/Li'
import Button from '../../components/Button'
import Confirmation from '../../components/Confirmation/Confirmation'
import DischargeModal from './Modal'
import { getDischarge, deleteDischarge } from '../../actions/medCenter/discharge'

export default function Discharge() {
  const dispatch = useDispatch()
  const { discharge, loading } = useSelector(state => state.directoryMedCenter)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(null)
  const [isDeleting, setIsDeleting] = useState(false)

  useEffect(() => {
    dispatch(getDischarge())
  }, [dispatch])

  const handleDelete = useCallback((id) => (e) => {
    e.stopPropagation()
    setConfirmation(id)
  }, [])

  const openModal = useCallback((data) => () => {
    setSelectedItem(data || {})
  }, [])

  const closeModal = useCallback(() => {
    setSelectedItem(null)
  }, [])

  const acceptConfirmation = useCallback(async () => {
    setIsDeleting(true)
    try {
      await dispatch(deleteDischarge(confirmation))
    } finally {
      setConfirmation(null)
      setIsDeleting(false)
    }
  }, [dispatch, confirmation])

  const rejectConfirmation = useCallback(() => {
    setConfirmation(null)
  }, [])

  const sortedList = useMemo(() => {
    if (!discharge) return []
    return [...discharge].sort((a, b) => a.discharge?.localeCompare(b.discharge))
  }, [discharge])

  const renderEmptyState = () => (
    <div className={styles.emptyState}>
      <BiMinusCircle size={64} className={styles.emptyIcon} />
      <p>Нет добавленных освобождений</p>
      <Button onClick={openModal()}>Добавить первое освобождение</Button>
    </div>
  )

  const renderLoading = () => (
    <div className={styles.loadingState}>
      <Puff
        height={50}
        width={50}
        color="#3689FF"
        ariaLabel="Загрузка..."
      />
      <span>Загрузка освобождений...</span>
    </div>
  )

  const renderList = () => (
    <>
      <ul className={styles.list}>
        {sortedList.map((item) => (
          <Li
            key={item.iddischarge}
            onClick={openModal(item)}
            className={styles.listItem}
          >
            <div className={styles.itemContent}>
              <span className={styles.itemName}>{item.discharge}</span>
            </div>
            <button
              type="button"
              className={styles.deleteBtn}
              onClick={handleDelete(item.iddischarge)}
              title="Удалить освобождение"
              aria-label={`Удалить ${item.discharge}`}
            >
              <BiTrash size={22} />
            </button>
          </Li>
        ))}
      </ul>
      <div className={styles.actions}>
        <Button onClick={openModal()}>Добавить освобождение</Button>
        <span className={styles.counter}>
          Всего: {sortedList.length}
        </span>
      </div>
    </>
  )

  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <h1>Освобождения</h1>
      </header>

      <main className={styles.content}>
        {loading && renderLoading()}
        {!loading && sortedList.length === 0 && renderEmptyState()}
        {!loading && sortedList.length > 0 && renderList()}
      </main>

      <DischargeModal
        open={selectedItem !== null}
        onClose={closeModal}
        data={selectedItem}
        addMode={selectedItem && !selectedItem.iddischarge}
      />

      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title="Уверены что хотите удалить освобождение?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
          loading={isDeleting}
        />
      )}
    </div>
  )
}
